// /hosts/story — the narrated pitch for prospective nexus hosts, in the
// investor-overture style. Lands on /hosts (the existing marketing page with
// the split calculator). Copy law: no em or en dashes visitor-side.
import React from "react";
import { useNavigate } from "react-router-dom";
import StoryOverture from "./StoryOverture";

export const HOST_SLIDES = [
  { w: 9, kind: "line", big: "You built an audience.",
    sub: "Give it a place to actually meet." },
  { w: 10, kind: "line", big: "A nexus is your own corner of Glonet.",
    sub: "Your brand. Your members. Your price." },
  { w: 10, kind: "pills", hot: 0,
    items: ["AI matching", "water cooler", "voice concierge", "member emails"] },
  { w: 10, kind: "line", big: "One payment, split three ways.",
    sub: "Platform, affiliates, you. The calculator shows every dollar." },
  { w: 8, kind: "stat", big: "$0", line: "to start.",
    sub: "You earn when your members pay." },
  { w: 9, kind: "line", big: "Bring affiliates of your own.",
    sub: "They grow your nexus. The split handles itself." },
  { w: 8, kind: "line", big: "The next page shows the math.",
    sub: "Set your price. See your share. Request access." },
];

export default function HostsStory() {
  const navigate = useNavigate();
  // both the skip and the natural end land AT THE CALCULATOR — the story's
  // last line promises "the next page shows the math"
  return (
    <StoryOverture
      slides={HOST_SLIDES}
      audioSrc="/hosts/audio/story.mp3"
      tagline="Glonet · Nexus Hosts"
      gateTitle="Your community, running as a nexus."
      skipLabel="Skip to the math"
      onDone={() => navigate("/hosts#calculator")}
    />
  );
}
